import { useCallback, useRef, useState } from 'react';
import type { FormikProps } from 'formik';

export function useDialogContextProvider({ open }: { open?: boolean }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formikRef = useRef<FormikProps<any> | null>(null);

  const clearFormikRef = useCallback(() => {
    formikRef.current = null;
  }, []);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const isControlled = typeof open !== 'undefined';

  const [showParentDialog, setShowParentDialog] = useState(
    isControlled ? open : false
  );

  if (isControlled && open && !showParentDialog) {
    setShowParentDialog(true);
  }

  if (isControlled && !open && showParentDialog) {
    setShowParentDialog(false);
  }

  const openConfirmDialogIfDirty = <T extends { preventDefault: () => void }>(
    e?: T
  ) => {
    const { dirty, isSubmitting } = formikRef.current || {};

    if (dirty && !isSubmitting) {
      e?.preventDefault(); // Prevent dialog from closing (Radix functionality)
      setShowConfirmDialog(true);
    }
  };

  return {
    showConfirmDialog,
    setShowConfirmDialog,
    showParentDialog,
    setShowParentDialog,
    formikRef,
    clearFormikRef,
    openConfirmDialogIfDirty,
  };
}
